import { Alert, AlertTitle } from "@mui/material"
import { WarningOutlined } from "@mui-symbols-material/w300"
import type { ReactElement } from "react"

const SyncWarningAlert = ({
  title = "Syncing with AS400… please wait.",
  message = "Some actions are temporarily disabled while synchronization is in progress.",
}: {
  title?: string
  message?: string
}): ReactElement => (
  <Alert icon={<WarningOutlined />} severity='warning' variant='filled' color='warning'>
    <AlertTitle>{title}</AlertTitle>
    {message}
  </Alert>
)

export default SyncWarningAlert
